import { HelpCircle } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface HelpIconProps {
  section: string;
}

export function HelpIcon({ section }: HelpIconProps) {
  const { navigateToHelp } = useNavigation();

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={() => navigateToHelp(section)}
            className="inline-flex items-center justify-center p-0.5 text-gray-400 hover:text-gray-900 dark:text-gray-500 dark:hover:text-gray-100 transition-colors"
            aria-label="Hilfe öffnen"
          >
            <HelpCircle className="w-4 h-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent>Hilfe</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
